import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { AbrirAtendimentoSelecionandoTipoCaso } from "../../../../Components/CardsPages/Atendimento/AbrirAtendimento";
import ProdutosHorizontal from "../../../../Components/CardsPages/ProdutosCobranca/ProdutosHorizontal";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useAtedimento } from "../../../../Context/Atendimento";
import { GetInfoContatoController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import { DesvincularTelefoneContatoController } from "../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import { IContatoComConta } from "../../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import { formatPhone, fullFormatPhone } from "../../../../Tools/FormatTools";
import VincularContato from "./VincularContato";

export function DadosContato() {
    const { chatAberto, updateChatAberto } = useAtedimento().HELP_DESK;

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>({} as IComponentModal);

    const [contato, setContato] = useState<IContatoComConta>(
        {} as IContatoComConta
    );
    const [idContato, setIdContato] = useState(0);

    useEffect(() => {
        if (chatAberto?.IdConta) {
            setIdContato(chatAberto?.IdConta);
            GetInfoContatoController(chatAberto.NumeroCliente).then((res) => {
                setContato(res);
            });
        }
    }, [chatAberto?.IdConta, chatAberto?.NumeroCliente]);

    return (
        <>
            {chatAberto?.IdConta && contato ? (
                <div>
                    <ProdutosHorizontal
                        idConta={idContato}
                        idProdutoAtendimento={0}
                    />
                    {contato.CONTATO ? (
                        <div>
                            <div className="">
                                <div>
                                    <span className="text-muted font-weight-bold h4">
                                        DADOS COLETADOS DO CONTATO:
                                    </span>
                                    <div className="d-flex flex-column align-items-start mt-4">
                                        {contato.CONTATO.DS_NOME ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-user mr-2"></i>{" "}
                                                {contato.CONTATO.DS_NOME}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {chatAberto.NumeroCliente ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-phone mr-2"></i>{" "}
                                                {fullFormatPhone(
                                                    chatAberto.NumeroCliente
                                                )}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.DS_EMAIL ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-envelope mr-2"></i>{" "}
                                                {contato.CONTATO.DS_EMAIL}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.NR_CPF ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-address-card mr-2"></i>{" "}
                                                {contato.CONTATO.NR_CPF}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.DT_NASCIMENTO ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-address-card mr-2"></i>{" "}
                                                {contato.CONTATO.DT_NASCIMENTO}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.ID_CHAVE_ERP ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-key mr-2"></i>{" "}
                                                {contato.CONTATO.ID_CHAVE_ERP}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.DS_BAIRRO ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                Bairro:{" "}
                                                {contato.CONTATO.DS_BAIRRO}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.DS_LOGRADOURO ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                Logradouro:{" "}
                                                {contato.CONTATO.DS_LOGRADOURO}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTATO.NR_CEP ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                CEP: {contato.CONTATO.NR_CEP}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div className="mt-6">
                                    <span className="text-muted font-weight-bold h4 mt-6">
                                        DADOS COLETADOS DA CONTA:
                                    </span>
                                    <div className="d-flex flex-column align-items-start mt-4">
                                        {contato.CONTA.DS_NOME ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-user mr-2"></i>{" "}
                                                {contato.CONTA.DS_NOME}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTA.DS_EMAIL ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-envelope mr-2"></i>{" "}
                                                {contato.CONTA.DS_EMAIL}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTA.DS_BAIRRO_COBRANCA ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                Bairro Cobrança:{" "}
                                                {
                                                    contato.CONTA
                                                        .DS_BAIRRO_COBRANCA
                                                }{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTA
                                            .DS_LOGRADOURO_COBRANCA ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                Logradouro Cobrança:{" "}
                                                {
                                                    contato.CONTA
                                                        .DS_LOGRADOURO_COBRANCA
                                                }{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTA
                                            .DS_COMPLEMENTO_COBRANCA ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-home mr-2"></i>{" "}
                                                Complemento Cobrança:{" "}
                                                {
                                                    contato.CONTA
                                                        .DS_COMPLEMENTO_COBRANCA
                                                }{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {contato.CONTA.DS_SITE_WEB ? (
                                            <span className="label label-light-dark label-inline mr-2 my-1">
                                                <i className="fas fa-globe-americas mr-2"></i>{" "}
                                                WEB SITE:{" "}
                                                {contato.CONTA.DS_SITE_WEB}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="offcanvas-footer d-flex align-items-center justify-content-center pb-7 pr-13"
                                    kt-hidden-height="47"
                                >
                                    <button
                                        type="button"
                                        className="btn btn-danger px-7"
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Deseja desvincular este contato?",
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                    DesvincularTelefoneContatoController(
                                                        formatPhone(
                                                            chatAberto.NumeroCliente
                                                        ),
                                                        contato.CONTATO
                                                            .ID_CONTATO,
                                                        contato.CONTATO
                                                            .ID_CONTATO_TELEFONE
                                                    ).then(() => {
                                                        updateChatAberto();
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        {" "}
                                        Desvincular{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="d-flex justify-content-center mt-5">
                        <button
                            className="btn btn-primary "
                            onClick={() => {
                                AbrirAtendimentoSelecionandoTipoCaso(
                                    setShow,
                                    setModal,
                                    {
                                        ID_MODULO: 0,
                                        editCliente: false,
                                        setShow: setShow,
                                        cliente: {
                                            ID_CONTA: contato.CONTA.ID_CONTA,
                                            DS_CONTA: contato.CONTA.DS_NOME,
                                            CONTATOS: [
                                                {
                                                    DS_NOME_CONTATO:
                                                        contato.CONTATO
                                                            .DS_NOME ?? "",
                                                    ID_CONTATO:
                                                        contato.CONTATO
                                                            .ID_CONTATO,
                                                },
                                            ],
                                            ID_CONTATO:
                                                contato.CONTATO.ID_CONTATO,
                                        },
                                        canalAtendimento: "Whatsapp",
                                        redirect: "TARGET_BLANK",
                                    }
                                );
                            }}
                        >
                            Abrir Atendimento
                        </button>
                    </div>
                </div>
            ) : (
                <div className="d-flex justify-content-center mt-5">
                    <button
                        className="btn btn-success "
                        onClick={() => {
                            setModal({
                                Component: () => VincularContato({ setShow }),
                                noFooter: true,
                                noHeader: true,
                                size: "lg",
                            });
                            setShow(true);
                        }}
                    >
                        Vincular Conta
                    </button>
                </div>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
